// The Discord level roles, in the order of the sprite sheet built by asset_src/ranks/build.sh.
export const RANKS = [
	{id: 'chicken', name: 'Jolly Chicken', level: 1},
	{id: 'wood', name: 'Jolly Wood', level: 3},
	{id: 'hammer', name: 'Jolly Hammer', level: 6},
	{id: 'axe', name: 'Jolly Axe', level: 10},
	{id: 'blade', name: 'Jolly Blade', level: 15},
	{id: 'bronze', name: 'Jolly Bronze', level: 20},
	{id: 'silver', name: 'Jolly Silver', level: 25},
	{id: 'gold', name: 'Jolly Gold', level: 30},
	{id: 'ruby', name: 'Jolly Ruby', level: 40},
	{id: 'diamond', name: 'Jolly Diamond', level: 50},
	{id: 'dragon', name: 'Jolly Dragon', level: 60},
];

// Same curve as pkg/discordxp in jollyworld-backend.
export const xpToNextLevel = level => 5 * level * level + 50 * level + 100;

export const levelProgress = xp => {
	let level = 0;
	while(xp >= xpToNextLevel(level)){
		xp -= xpToNextLevel(level);
		level++;
	}
	return {level, xp, needed: xpToNextLevel(level)};
};

export const rankForLevel = level => RANKS.filter(rank => rank.level <= level).pop() || null;
export const nextRank = level => RANKS.find(rank => rank.level > level) || null;

export const showRankIcon = (element, rank) => {
	element.style.backgroundPositionX = `${RANKS.indexOf(rank) / (RANKS.length - 1) * 100}%`;
};
